import { Button } from '@design-systems/canvas-ui'
import Icon, { DatabaseIcon } from '@design-systems/react-icons'
import { BRAND_LIFECYCLE_STATUS } from '../config/brandLifecycleConfig'

// The banner shown while the brand is extracting or in review, with the way
// into the review once there is one. Renders nothing in any other state.
const ExtractionStatusNotice = ({ lifecycleStatus, onOpenReview }) => {
  const isExtractionInProgress =
    lifecycleStatus === BRAND_LIFECYCLE_STATUS.EXTRACTION_IN_PROGRESS
  const isInReview = lifecycleStatus === BRAND_LIFECYCLE_STATUS.IN_REVIEW
  if (!isExtractionInProgress && !isInReview) return null

  return (
    <div className="upload-documents__notice">
      <Icon size="lg" svg={DatabaseIcon} />
      <span>
        <strong>
          {isExtractionInProgress
            ? 'Extraction in progress'
            : 'Extraction complete — start reviewing'}
        </strong>
        {isInReview && (
          <Button onClick={onOpenReview} variant="primary">
            Review
          </Button>
        )}
      </span>
    </div>
  )
}

export default ExtractionStatusNotice
